module.exports = __webpack_public_path__ + "img/func_5_3.46ab0619.svg";